// extracted by mini-css-extract-plugin
module.exports = {"email":"PageChangeEmail__email__3ELZV","password":"PageChangeEmail__password__2EZPv"};